import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getUploadLogs } from 'actions/uploadlogs'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { Container } from 'components/layout/Grid/'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { hasAccess } from 'utils/hasAccess'

class UploadLogsTax extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    getUploadLogs: PropTypes.func.isRequired,
    uploadLogs: PropTypes.object.isRequired,
  }
  componentDidMount() {
    const currentUser = this.props.currentUser
    const access = hasAccess(this.props.currentUser, 'Tax Statements', this.props.history)
    if (access) {
      this.props.getUploadLogs('TaxStatementsLogs')
    }
  }

  render() {
    const { routes, currentUser } = this.props
    const backToAdminCentreText = 'Tax statements upload status'
    return (
      <div><BackToAdminCentre displayText={backToAdminCentreText} isAdmin={this.props.currentUser.IsAdmin} /><Container>
        {routes.map((route, i) => (
          <RouteWithSubRoutes
            key={i}
            {...route}
            backToAdminCentreText={backToAdminCentreText}
            currentUser={currentUser}
            getUploadLogs={this.props.getUploadLogs}
            setErrorMessage={this.props.setErrorMessage}
            uploadLogs={this.props.uploadLogs}
          />
        ))}
      </Container></div>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  uploadLogs: state.uploadLogs,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getUploadLogs,
})(UploadLogsTax))



// WEBPACK FOOTER //
// ./src/containers/UploadLogsTax.js